import { IConfig } from 'shared/map-search/types/config';

const initialState: IConfig = {
  newbuildingNewPromoPinsEnabled: false,
  adfoxMapBannerConfig: [],
};

export const configReducer = (state = initialState) => {
  return state;
};
